<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button
          @click="
            showEdit = true;
            queryDept();
          "
          type="primary"
          icon="el-icon-plus"
          class="ele-btn-icon"
          size="small"
          >添加物品
        </el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 261px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="name" label="名称" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column label="分配人员" sortable="custom" show-overflow-tooltip>
            <template #default="{ row }">
              <el-tag v-for="item in row.teacherList" :key="item.id" type="primary" size="mini">{{ item.teacherName }} </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-popconfirm title="确定要删除此物品吗？" @onConfirm="removeGoods(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>

    <el-dialog
      title="添加物品"
      :visible.sync="showEdit"
      width="450px"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      @closed="editForm = {}"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px" @submit.native.prevent>
        <el-form-item label="物品名称:" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入物品名称" clearable />
        </el-form-item>
        <el-form-item label="接收人" prop="teacherIds">
          <treeselect
            v-model="editForm.teacherIds"
            :options="teacherList"
            :required="true"
            :multiple="true"
            placeholder="请选择教师"
            :defaultExpandLevel="2"
            valueConsistsOf="LEAF_PRIORITY"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { delGoods, getAllDepartTeachers, saveGoods } from '@/config/api';

  export default {
    name: 'Goods',
    components: { Treeselect },
    data() {
      return {
        table: {
          url: '/school/repair/goods/list',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        showEdit: false, // 添加问卷调查弹窗
        editForm: {
          name: '',
        },
        editRules: {
          // 表单验证规则
          name: [{ required: true, message: '请输入物品名称', trigger: 'blur' }],
        },
        choose: [],
        teacherList: [],
      };
    },
    methods: {
      // 查询部门老师列表
      queryDept() {
        getAllDepartTeachers()
          .then((res) => {
            if (res.data.resCode == 200) {
              this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
              this.deleteChildren(this.teacherList);
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].type !== 2) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
      // 添加物品
      save() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            let teacherIds = [...new Set(this.editForm.teacherIds)]; //js去重
            let formData = new FormData();
            formData.append('teacherIds', teacherIds);
            formData.append('name', this.editForm.name);
            saveGoods(formData).then((res) => {
              if (res.data.resCode == 200) {
                this.$message.success('添加成功');
                this.showEdit = false;
                this.$refs.table.reload();
              }
            });
          } else {
            return false;
          }
        });
      },
      removeGoods(row) {
        delGoods(row.id).then((res) => {
          if (res.data.resCode == 200) {
            this.$message.success('删除成功');
            this.$refs.table.reload();
          }
        });
      },
    },
  };
</script>

<style scoped></style>
